import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Card, F0TagStatus } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import { ElementPreview } from 'modules/forms/components/preview/ElementPreview'
import { Element } from 'modules/forms/lib/Element'
import { Form } from 'modules/forms/lib/Form'
import { SectionElement } from 'modules/forms/lib/elements/SectionElement'

interface FormResponsesInlineProps {
  form: Form
  showElementName?: boolean
  titleSize?: 'default' | 'small'
}

const renderFeedbackTag = (element: Element) => {
  if (!element.hasCorrectAnswer) {
    return null
  }
  const isCorrect = element.answer?.isCorrect
  return (
    <F0TagStatus
      text={
        isCorrect
          ? i18n.t('trainings.content.consumer.quiz.questions.correct')
          : i18n.t('trainings.content.consumer.quiz.questions.incorrect')
      }
      variant={isCorrect ? 'positive' : 'critical'}
    />
  )
}

const FormResponsesInline: React.FC<FormResponsesInlineProps> = ({
  form,
  showElementName = true,
  titleSize = 'default',
}) => {
  return (
    <Box gap="s24">
      {form.elements.map((element: Element, index: number) => (
        <React.Fragment key={element.uuid}>
          <Box gap="s16" paddingLeft="s24">
            <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
              <Text.Normal whiteSpace="nowrap">{`Question ${index + 1}`}</Text.Normal>
              {renderFeedbackTag(element)}
            </Box>
            <F0Card>
              <ElementPreview
                element={element}
                mode="response_without_score"
                showElementName={showElementName}
                titleSize={titleSize}
              />
            </F0Card>
          </Box>
          {element instanceof SectionElement && (
            <>
              {element.elements.map((child: Element, childIndex: number) => (
                <React.Fragment key={child.uuid}>
                  <Box gap="s8">
                    <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
                      <Text.Normal whiteSpace="nowrap">{`Question ${index + 1}.${
                        childIndex + 1
                      }`}</Text.Normal>
                      {renderFeedbackTag(child)}
                    </Box>
                    <F0Card>
                      <ElementPreview
                        element={child}
                        mode="response_without_score"
                        showElementName={showElementName}
                        titleSize={titleSize}
                      />
                    </F0Card>
                  </Box>
                </React.Fragment>
              ))}
              <Box flexDirection="row" alignItems="center">
                <Box
                  width="full"
                  className="border-solid border-0 border-t border-f1-border-secondary"
                />
                <Text.Normal whiteSpace="nowrap" className="text-base p-3">
                  {i18n.t('forms.section_end')}
                </Text.Normal>
                <Box
                  width="full"
                  className="border-solid border-0 border-t border-f1-border-secondary"
                />
              </Box>
            </>
          )}
        </React.Fragment>
      ))}
    </Box>
  )
}

export default FormResponsesInline
